import { render, staticRenderFns } from "./mobileUserMenu.vue?vue&type=template&id=82c5c3a8&scoped=true&"
import script from "./mobileUserMenu.vue?vue&type=script&lang=js&"
export * from "./mobileUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./mobileUserMenu.vue?vue&type=style&index=0&id=82c5c3a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c5c3a8",
  null
  
)

export default component.exports